module.exports = __webpack_public_path__ + "static/media/vue.c8490286.svg";